export const COMPETENCE_FORM = 'COMPETENCE_FORM'

export const ADD_COMPETENCE_FORM = 'ADD_COMPETENCE_FORM'

export const FORM_FIELDS = {
	NOM: 'nom',
	TYPE_COMPETENCE: 'typeCompetence',
	DESCRIPTION: 'description'
} as const

// Champs obligatoires du formulaire, dans l'ordre d'affichage
export const REQUIRED_FIELDS = [FORM_FIELDS.TYPE_COMPETENCE, FORM_FIELDS.NOM]

export const MESSAGE_BASE = 'bo.competences'
